<template>
  <div class="promoter-list" ref="container">
    <div class="header">
      <!-- <div class="promoterHeader bg-color-red">
        <div class="headerCon acea-row row-between-wrapper">
          <div>
            <div class="name">消费券使用总额：<span class="num">{{ all }}</span></div>
          </div>
          <div class="iconfont icon-tuandui"></div>
        </div>
      </div> -->
      <div class="search acea-row row-between-wrapper">
        <!-- <form @submit.prevent="submitForm">
          <div class="input">
            <input placeholder="点击搜索手机号" v-model="screen.phone"/>
            <input placeholder="点击搜索UID" v-model="screen.uid" />
            <span class="iconfont icon-guanbi" @click="clearKeyword()"></span>
          </div>
        </form> -->

        <form @submit.prevent="submitForm">
          <div class="input">
            <input placeholder="输入手机号 / UID进行搜索" v-model="searchKeyword"/>
            <span class="iconfont icon-guanbi" @click="clearKeyword()"></span>
          </div>
        </form>
        <div class="iconfont icon-sousuo2" @click="submitForm()"></div>
      </div>
    </div>
    <div class="list">
      <div
        class="sortNav acea-row row-middle"
        :class="fixedState === true ? 'on' : ''"
      >
        <div class="sortItem" @click="sort('consumerVoucher')">
            <!-- <div class="sortItem"> -->
          消费券
          <img src="@assets/images/sort1.png" v-if="childCount == 1" />
          <img src="@assets/images/sort2.png" v-if="childCount == 2" />
          <img src="@assets/images/sort3.png" v-if="childCount == 3" />
        </div>
        <div class="sortItem" @click="sort('nowMoney')">
            <!-- <div class="sortItem"> -->
          余额
          <img src="@assets/images/sort1.png" v-if="numberCount == 1" />
          <img src="@assets/images/sort2.png" v-if="numberCount == 2" />
          <img src="@assets/images/sort3.png" v-if="numberCount == 3" />
        </div>
        <!-- <div class="sortItem" @click="sort('orderCount')"> -->
        <!-- <div class="sortItem">
          金额 -->
          <!-- <img src="@assets/images/sort1.png" v-if="orderCount == 1" />
          <img src="@assets/images/sort2.png" v-if="orderCount == 2" />
          <img src="@assets/images/sort3.png" v-if="orderCount == 3" /> -->
        <!-- </div> -->
      </div>
      <div :class="fixedState === true ? 'sortList' : ''">
        <router-link
          class="item acea-row row-between-wrapper"
          v-for="(val, index) in spreadList"
          :key="index"
          :to="{
            path: '/user/user_voucher_detail',
            query: { uid: val.uid }
          }"
        >
          <div class="picTxt acea-row row-between-wrapper">
            <!-- <div class="pictrue">
              <img :src="val.avatar" />
              <div class="divright" v-if="val.vipIcon">
                <img :src="val.vipIcon" />
              </div>
            </div> -->
            <div class="text">
              <!-- <div class="name line1">{{ val.uid }}-{{ val.mobile }}</div> -->
              <div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">uid:{{ val.uid }}</div>
              <div>手机号: {{ val.phone }}</div>
            </div>
          </div>
          <div class="right">
            <div>
              余额:<span class="font-color-red">{{ val.now_money  }}</span> 元
            </div>
            <div>
              消费券:<span class="font-color-red">{{ val.consumer_voucher }}</span> 元
            </div>
            <!-- <div>{{ val.orderCount }} 单</div>
            <div>{{ val.numberCount ? val.numberCount : 0 }} 元</div> -->
          </div>
        </router-link>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<script>
import { userList } from "../../../api/user";
import Loading from "@components/Loading";
export default {
  name: "PromoterList",
  components: {
    Loading
  },
  props: {},
  data: function() {
    return {
      fixedState: false,
      screen: {
        page: 1,
        limit: 15,
        grade: 0,
        phone: "",
        order: "",
        uid: ""
      },
      childCount: 2,
      numberCount: 2,
      orderCount: 2,
      loaded: false,
      loading: false,
      spreadList: [],
      loadTitle: "",
      first: "",
      second: "",
      all: 0,
      mouth: "",
      searchKeyword: ""
    };
  },
  mounted: function() {
    this.getSpreadUsers();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getSpreadUsers();
    });
  },
  watch: {
    "screen.sort": function() {
      this.screen.page = 0;
      this.loaded = false;
      this.loading = false;
      this.spreadList = [];
      this.getSpreadUsers();
    }
  },
  methods: {
    clearKeyword: function() {
      this.searchKeyword = "";
    },
    handleScroll: function() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      var offsetTop = document.querySelector(".header").clientHeight;
      if (scrollTop >= offsetTop) {
        this.fixedState = true;
      } else {
        this.fixedState = false;
      }
    },
    submitForm: function() {
      this.screen.page = 0;
      this.loaded = false;
      this.loading = false;
      this.spreadList = [];

      // 检查输入的是手机号还是UID（这里假设手机号是11位数字，UID是任意字符串）
      if (/^\d{11}$/.test(this.searchKeyword)) {
        // 手机号
        console.log('搜索手机号:', this.searchKeyword);
        // 执行手机号搜索逻辑
        this.screen.phone = this.searchKeyword;
      } else {
        // UID
        console.log('搜索UID:', this.searchKeyword);
        // 执行UID搜索逻辑
        this.screen.uid = this.searchKeyword;
      }

      this.getSpreadUsers();
    },
    getSpreadUsers: function() {
      let that = this,
        screen = that.screen;
      if (that.loaded || that.loading) return;
      that.loading = true;

      // console.log("==========123123123============");
      // console.log(screen);
      // console.log("==========321321321============");

      userList(screen).then(
        res => {
          let spreadData = res.data.list;
          that.loading = false;
          that.spreadList.push.apply(that.spreadList, spreadData);
          that.loaded = res.data.list.length < that.screen.limit; //判断所有数据是否加载完成；
          that.loadTitle = that.loaded ? "人家是有底线的" : "上拉加载更多";
          that.screen.page = that.screen.page + 1;
          that.all = res.data.all;
          // that.second = res.data.totalLevel;
          // that.mouth = res.data.mouthLevel;
        },
        error => {
          that.$dialog.message(error.msg);
        },
        300
      );
    },
    checkGrade: function(val) {
      if (val == this.screen.grade) return;
      else {
        this.screen.page = 1;
        this.screen.grade = val;
        this.loading = false;
        this.loaded = false;
        this.spreadList = [];
        this.getSpreadUsers();
      }
    },
    sort: function(types) {
      let that = this;
      switch (types) {
        case "consumerVoucher":
          if (that.childCount == 2) {
            that.childCount = 1;
            that.orderCount = 2;
            that.numberCount = 2;
            that.screen.order = "consumer_voucher DESC";
          } else if (that.childCount == 1) {
            that.childCount = 3;
            that.orderCount = 2;
            that.numberCount = 2;
            that.screen.order = "consumer_voucher ASC";
          } else if (that.childCount == 3) {
            that.childCount = 2;
            that.orderCount = 2;
            that.numberCount = 2;
            that.screen.order = "";
          }
          break;
        case "nowMoney":
          if (that.numberCount == 2) {
            that.numberCount = 1;
            that.orderCount = 2;
            that.childCount = 2;
            that.screen.order = "now_money DESC";
          } else if (that.numberCount == 1) {
            that.numberCount = 3;
            that.orderCount = 2;
            that.childCount = 2;
            that.screen.order = "now_money ASC";
          } else if (that.numberCount == 3) {
            that.numberCount = 2;
            that.orderCount = 2;
            that.childCount = 2;
            that.screen.order = "";
          }
          break;
        default:
          that.screen.sort = "";
      }
    }
  }
};
</script>